// src/lib/editLockKey.js
//
// Clave única para coordinar, POR DOCUMENTO (workspace/día/perfil), la
// transacción de edición, el autoguardado y los snapshots. La MISMA función
// se usa como:
//   - clave del lock en editLocksRef (AppCore.jsx / dogDayManagerActions.js)
//   - docKey de la cola FIFO en docWriteQueue.js (autoguardado y
//     transacciones de weekOfChange comparten exactamente esta cola).
//
// No duplicar este formato en ningún otro punto del código.

/**
 * @param {string} workspaceId
 * @param {string} profileId
 * @param {string} dateKey - "YYYY-MM-DD"
 * @returns {string}
 */
export function makeEditLockKey(workspaceId, profileId, dateKey) {
  return `${workspaceId}::${profileId}::${dateKey}`;
}
